import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocationID } from "models";

export const useImportLogQuery = (locationId: DealerLocationID) =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.importLog(locationId),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.import_logs
  });
